import {
  DocumentAnyData,
  PreviousDocument,
  SupportingDocument,
  TransportDocument,
} from 'features/declaration/models/schemas/documentSchemas'
import {
  TransitOperationFormValues,
  TransitOperationData,
} from 'features/declaration/models/schemas/transitOperationFormSchema'
import { excludeDeleted } from 'shared/lib/common-util'
import createDocumentSaver from '../../document/components/createDocumentSaver'
import { toDocumentSaveBatch } from '../../document/models/formValuesToModel'
import resequenceDocuments from '../../document/models/resequence'
import { createConsignmentDocuments } from '../api/createConsignmentDocuments'
import { updateConsignmentDocuments } from '../api/updateConsignmentDocuments'

function getDocumentFromForm(formValues: TransitOperationData): DocumentAnyData[] {
  const existingTransportDocuments: TransportDocument[] = resequenceDocuments(formValues.transportDocument.filter(excludeDeleted))
  const existingPreviousDocuments: PreviousDocument[] = resequenceDocuments(formValues.previousDocument.filter(excludeDeleted))
  const existingSupportingDocuments: SupportingDocument[] = resequenceDocuments(formValues.supportingDocument.filter(excludeDeleted))

  return [
    ...existingTransportDocuments,
    ...existingPreviousDocuments,
    ...existingSupportingDocuments,
  ] as DocumentAnyData[]
}

export default function useSaveConsignmentDocuments() {
  const saveConsignmentDocuments = async (
    transitOperationId: number,
    consignmentId: number,
    formValues: TransitOperationFormValues,
  ) => {
    const saveDocuments = createDocumentSaver({
      createDocumentsFn: (documents) => createConsignmentDocuments(transitOperationId, consignmentId, documents),
      updateDocumentsFn: (documents) => updateConsignmentDocuments(transitOperationId, consignmentId, documents),
    })

    const documents = toDocumentSaveBatch(getDocumentFromForm(formValues))

    return saveDocuments(documents)
  }

  return { saveConsignmentDocuments }
}
